<template>
    <div>
        <b-modal size="lg" id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-send-document"
            @hidden="resetModal">
            <div class="container wrap-form-save-class-school">
                <h4 class="title-header">
                    <strong>{{id==0?'Gửi tài liệu':'Tài liệu'}}</strong>
                </h4>
                <div class="p-3">
                    <div class="form-group row">
                        <div class="col-md-12">
                            <label class="label-form" for="link">Điền link tài liệu:</label>
                        </div>
                        <div v-if="id==0" class="col-md-10">
                            <b-form-input v-model="form.link" placeholder="https://...." id="link" type="text"></b-form-input>
                        </div>
                        <div v-else class="col-md-10">
                            <div class="content-link" @click="handleRedirectLink">{{ form.link }}</div>
                        </div>
                    </div>
                    <div class="form-group custom-line">
                        <div class="line1">
    
                        </div>
                        <div class="text-line">
                            hoặc
                        </div>
                        <div class="line1">
    
                        </div>
                    </div>
                    <div class="form-group row">
                        
                        <input
                                    hidden
                                    type="file"
                                    name="file"
                                    id="fileInputUpload"
                                    class="hidden-input"
                                    @change="onChangeUploadFile"
                                    ref="file"
                                    accept=".pptx,.docx,.xlsx,.pdf,.h5p"
                                />
                        <div v-if="!form.file && !form.path && id==0" class="width-full">
                            <div class="col-md-12">
                                <label for="code">Tải tài liệu lên</label>
                            </div>
                            <div 
                                @dragover="dragoverUploadFile"
                                @dragleave="dragleaveUploadFile"
                                @drop="dropUploadFile"
                                class="wrap-upload-file display-flex-center justify-content-between cg-1"
                                :class="isDragging?'upload-drag':''"
                            >
                            
                                <div class="upload-file-left">
                                    <img class="icon-upload" width="60px" src="@/assets/img/upload.png" />
                                </div>
                                <div class="upload-file-center">
                                    <div><strong>Thêm hoặc kéo thả</strong></div>
                                    <div>
                                        JPG, PNG hoặc PDF, và các điều kiện khác như dung lượng nếu có
                                    </div>
                                    <!-- <div>
                                        Mỗi lần chỉ tải 1 file, dung lượng file không vượt quá 15MB
                                    </div> -->
                                </div>
                                <div class="upload-file-right">
                                    <button 
                                    @click="onUploadFile"
                                    type="button"
                                        class="btn btn-outline-primary btn-upload py-3 border-rd-8 display-flex-center justify-content-center line-height-1">
                                        CHỌN FILE
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" v-else>
                            <label for="name">File:</label>
                                <div class="wrap-file-data row col-md-12">
                                    
                                    <div class="wrap-left col-md-6">
                                        <img class="icon-photo" src="@/assets/img/photo.png" />
                                        &nbsp;
                                        <span class="name-file">
                                            {{ form.fileName }}
                                        </span>
                                    </div>
                                    <div v-if="id==0" class="wrap-right col-md-6">
                                        <span class="size-file">{{ formatSizeFile(form.sizeFile) }}</span>
                                        &nbsp;
                                        <img @click="handleOnRemoveFile" class="btn-delete" src="@/assets/img/icon-close.png" />
                                    </div>
                                    <button v-else type="button"
                                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center line-height-1"
                                        @click="handleDownLoadFile">
                                        Tải xuống
                                    </button>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="form_action display-flex-center">
                    <button type="button"
                        class="btn font-size-16 form-30h display-flex-center line-height-1"
                        @click="handleHideModal">
                        Hủy
                    </button>
                    <button v-if="id==0" type="button"
                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center line-height-1"
                        @click="handleSendDocument"
                        :disabled="isDisabledButton"
                        >
                        Gửi
                    </button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import {saveTeacherDocumentClassSchool,getDetail,downloadFile} from './../_api/teacherDocumentClassSchoolServices'

export default {
    name: "ModalSendDocument",
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        },
        id:{
            type:Number,
            default:0
        }
    },
    components: {
    },
    data() {
        return {
            isDisabledButton:false,
            isDragging: false,
            form: {
                id: 0,
                classSchoolId: 0,
                link:'',
                file:null,
                fileName:'',
                sizeFile:0
            },
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    mounted() {
        this.form.classSchoolId = this.classSchoolId
        this.handleShowModal()
        if(this.id>0){
            this.getDetailDocument()
        }
    },

    methods: {
        fixUrl(url) {
            // Kiểm tra nếu URL không bắt đầu bằng "https://"
            if(url.includes('http:')){
                return url
            }
            if (!url.startsWith("https://")) {
                // Thêm "https://" vào đầu URL
                url = "https://" + url;
            }
            
            return url;
        },
        handleRedirectLink(){
            window.open(this.fixUrl(this.form.link), '_blank');
        },
        handleDownLoadFile(){
            let params = {
                path:this.form.path,
                fileName:this.form.fileName,
            }
            downloadFile(params)
        },
        getDetailDocument(){
            getDetail(this.id).then((res)=>{
                
                if (res && res.data && !res.errors) {
                    this.form =  {
                        id: res.data.id,
                        classSchoolId: res.data.classSchoolId,
                        link:res.data.link,
                        file:res.data.file,
                        path:res.data.path,
                        fileName:res.data.fileName,
                        sizeFile:0
                    } 
                    console.log(this.form)
                }
                
            })
        },
        resetModal() {

        },
        handleOnRemoveFile(){
            this.$refs.file.value = '';
            this.form.file = null
            this.form.path = ''
            this.form.fileName=''
        },
        formatSizeFile(data, to='MB') { 
            const const_term = 1024; 
        
            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") { 
                return (data / const_term).toFixed(3) + "KB"; 
            } else if (to === "MB") { 
                return (data / const_term ** 2).toFixed(3) + "MB"; 
            } else if (to === "GB") { 
                return (data / const_term ** 3).toFixed(3) + "GB"; 
            } else if (to === "TB") { 
                return (data / const_term ** 4).toFixed(3) + "TB"; 
            } else { 
                return ""; 
            } 
        }, 
        handleShowModal() {
            this.$refs['modal-send-document'].show()
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleSendDocument() {
            let self = this
            if(!this.form.file && !this.form.link){
                this.$toast.error('Vui lòng nhập linh tài liệu hoặc file đính kèm')
            }
            const formData = new FormData();
            formData.append('id', this.form.id);
            formData.append('file', this.form.file);
            formData.append('link', this.form.link);
            formData.append('classSchoolId', this.classSchoolId);
            this.isDisabledButton = true
            saveTeacherDocumentClassSchool(formData).then(res => {
                    if (res && res.data && !res.errors) {
                        self.$toast.success('Gửi tài liệu thành công')
                        self.handleDone()
                    }
                    this.isDisabledButton = false
                })
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        onUploadFile(){
            this.$refs.file.click()
        },
        onChangeUploadFile(){
            this.form.file = this.$refs.file.files[0]
            this.form.sizeFile = this.form.file.size
            this.form.fileName= this.form.file.name
        },
        dragoverUploadFile(e){
            e.preventDefault();
            this.isDragging = true;
        },
        dragleaveUploadFile(){
            this.isDragging = false;
        },
        dropUploadFile(e){
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChangeUploadFile();
            this.isDragging = false;
        },
    }
}
</script>

<style lang="scss" scoped>
.content-link{
    color: blue;
    cursor: pointer;
}
.btn-delete{
            cursor: pointer;
            width: 20px;
            height: 20px;
        }
.icon-photo{
            width: 30px;
        }
.btn-copy {

    // margin: 5px 0px 5px 0px;
    // background: white;
    // color: black;
    // border: 1px solid #d5d2d2;
    .icon-copy,
    .icon-link {
        width: 20px;
    }
}

.custom-line {
    display: flex;
    margin-top: 30px;
    padding-left: 20px;
    padding-right: 20px;

    .line1 {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
    }

    .line2 {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
    }

    .text-line {
        margin-top: -10px;
        padding-left: 10px;
        padding-right: 10px;
        color: #e5e5e5;
    }
}

.icon-link {
    width: 20px;
}

.padding-left-20 {
    padding-left: 20px;
}

.padding-right-20 {
    padding-right: 20px;
}

.btn-copy {
    margin: 5px 0px 5px 0px;
    background: white;
    color: black;
    border: 1px solid #d5d2d2;
    width: 100%;
}

.label-form {
    font-size: 14px;
}

.text-center {
    text-align: center;
}

.modal-content {
    background-color: red;
}

.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;
}

.form_action {
    justify-content: center;
    column-gap: 5rem;
}
.btn-main {
    padding-left: 3rem;
    padding-right: 3rem;
}
.btn-upload {
    height: auto;
}
.justity-content-space-around {
    justify-content: space-around
}
.wrap-upload-file {
    border: 1px;
    border-style: dashed;
    border-radius: 10px;
    padding: 1.2rem 1.6rem;
}
</style>